<template>
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 6.4C0 4.15979 0 3.03969 0.435974 2.18404C0.819467 1.43139 1.43139 0.819467 2.18404 0.435974C3.03969 0 4.15979 0 6.4 0H17.6C19.8402 0 20.9603 0 21.816 0.435974C22.5686 0.819467 23.1805 1.43139 23.564 2.18404C24 3.03969 24 4.15979 24 6.4V17.6C24 19.8402 24 20.9603 23.564 21.816C23.1805 22.5686 22.5686 23.1805 21.816 23.564C20.9603 24 19.8402 24 17.6 24H6.4C4.15979 24 3.03969 24 2.18404 23.564C1.43139 23.1805 0.819467 22.5686 0.435974 21.816C0 20.9603 0 19.8402 0 17.6V6.4Z"
      fill="#E8ECEF"
    />
    <path
      class="nlp__svg-path"
      d="M12.8034 11.5894L18.2043 19.3145H15.9878L11.5806 13.0108V13.0104L10.9335 12.085L5.78516 4.7207H8.00168L12.1564 10.664L12.8034 11.5894Z"
      fill="#5A627D"
    />
    <g clip-path="url(#clip0_107_9196)">
      <path
        class="nlp__svg-path"
        d="M13.4893 10.7749L19.3176 4H17.9365L12.8758 9.88256L8.8338 4H4.17188L10.2841 12.8955L4.17188 20H5.55307L10.8973 13.7878L15.1659 20H19.8278L13.4893 10.7749ZM11.5976 12.9738L10.9783 12.0881L6.05073 5.03974H8.17217L12.1487 10.728L12.768 11.6137L17.9371 19.0075H15.8157L11.5976 12.9738Z"
        fill="#5A627D"
      />
    </g>
    <defs>
      <clipPath id="clip0_107_9196">
        <rect
          fill="white"
          height="16"
          transform="translate(4 4)"
          width="16"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'NlpTwitter',
}
</script>